// Feature flags used in the app should be defined here to keep names centralized.
// This file is intentionally free of posthog-js imports so it can be safely
// imported by Server Components (e.g. navigation.ts → admin/page.tsx).
export enum FeatureFlag {
  EVENT_IMPORT_TOOL = 'event-import-tool',
  LANDING_CTA_COUNTRY = 'landing-cta-country',
  LOCATION_PAYMENT_RESET = 'location-payment-reset',
  STRIPE_CONNECT = 'stripe-connect',
  SUPER_ADMIN = 'super-admin',
}
